import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';
import Utility from '../../util/utilityfunctions';
import {FilterEntityConfiguration} from '../../components/Common/Filter/config';
import _ from 'lodash';

export default function filterdatareducer(state = initialstate.filterData, action) {
	switch (action.type) {
		case actions.GET_FILTER_ENTITIES:
			{
				if (action.response) {
					const entityMapping = action.dataMapping || FilterEntityConfiguration[action.entityType]?.entityMapping;

					const data =
						entityMapping !== undefined && typeof entityMapping === 'function'
							? entityMapping(action.response)
							: action.response;

					return {
						...state,
						[action.key]: {
							...state[action.key],
							[action.name]: Utility.normalize(data, undefined, 'value')
						}
					};
				}
			}

			return state;

		default:
			return state;
	}
}
